<template>
    <v-container>

        <v-row>
            <!-- LEFT SIDE -->
            <v-col cols="12" md="8">
                <v-row>
                    <v-col cols="12">
                        <new-messages/>
                        <no-phone-set/>
                        <subscription-status/>
                    </v-col>
                    <v-col cols="12" class="hello-text text-capitalize">
                        {{ helloName }}
                    </v-col>
                    <v-col cols="12">
                        <student-progress-table :coach-id="coachId"/>
                    </v-col>
                    <v-col cols="12">
                        <student-competence :coach-id="coachId"/>
                    </v-col>
                </v-row>
            </v-col>
            <!-- RIGHT SIDE -->
            <v-col cols="12" md="4">
                <v-row>
                    <v-col cols="12" class="title-section pb-0">
                        {{ $t('common.panel_monthly') }}
                    </v-col>
                    <v-col cols="12">
                        <calendar-mobile home-view bordered force-calendar :default-date="currentDate"/>
                    </v-col>
                    <v-col cols="12">
                        <youtube-upload-links/>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>

import NewMessages from "@/components/elements/alerts/NewMessages";
import NoPhoneSet from "@/components/elements/alerts/NoPhoneSet";
import SubscriptionStatus from "@/components/student/SubscriptionStatus";
import CalendarMobile from "@/components/coach/routines/CalendarMobile";
import StudentProgressTable from "@/components/student/StudentProgressTable";
import StudentCompetence from "@/components/coach/StudentCompetence";
import YoutubeUploadLinks from "@/components/coach/YoutubeUploadLinks";
import {updateDocuments} from "@/utils/Helpers";

export default {
    components: {
        YoutubeUploadLinks,
        StudentCompetence,
        NoPhoneSet,
        NewMessages,
        SubscriptionStatus,
        StudentProgressTable,
        CalendarMobile,
    },
    data() {
        return {
            currentDate: null,
        }
    },
    computed: {
        helloName(vm = this) {
            return vm.$t('common.hello', {name: vm.account?.name || ''})
        },
        coachId(vm = this) {
            return vm.currentUser?.uid || null
        }
    },
    async mounted() {
        let vm = this
        vm.currentDate = vm.$moment().format('YYYY-MM-DD')
        // await updateDocuments('assignedRoutines')
    }
}
</script>

<style scoped>

.hello-text {
    font-size: 24px;
    line-height: 24px;
    font-weight: bold;
    color: #269999;
}

.title-section {
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
}

</style>